import { render, staticRenderFns } from "./BetaFunctionCard.vue?vue&type=template&id=570ca181&scoped=true&"
import script from "./BetaFunctionCard.vue?vue&type=script&lang=js&"
export * from "./BetaFunctionCard.vue?vue&type=script&lang=js&"
import style0 from "./BetaFunctionCard.vue?vue&type=style&index=0&id=570ca181&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ca181",
  null
  
)

export default component.exports